<template>
  <v-container>
    <form ref="form" class="map-search-form form-horizontal" action=""
          @submit.prevent="goToSearchedLocation">
    <v-layout row>

          <v-flex md10>
            <v-text-field
                    outlined
                    v-model="mapSearch"
                    hide-details
            ></v-text-field>
          </v-flex>

          <v-flex md2>
            <v-btn
                    style="margin-left: 20px; margin-top: 2px"
                    x-large
                    color="primary"
                    :loading="searchLoading"
                    @click="goToSearchedLocation">
              Search
            </v-btn>
          </v-flex>
      </v-layout>
    </form>



    <v-layout row>
      <v-flex xs12>
        <div id="map"></div>
      </v-flex>
    </v-layout>

    <v-layout row>
      <v-flex md3>

        <form class="optionForm">
          <h4>Options:</h4>
          <div>
            <v-container fluid>
              <v-checkbox
                      v-model="lakes" label="Lakes"
              ></v-checkbox>

              <v-text-field
                      outlined
                      style="display:none"
                      v-model="scaleImage"
                      label="Scale"
              ></v-text-field>

            </v-container>
          </div>

          <v-btn
                  x-large
                  color="primary"
                  :loading="loading"
                  @click="generate">
            Generate
          </v-btn>

        </form>
      </v-flex>

      <v-flex md9>
        <div class="result">
          <p v-if="loading">Loading...</p>
          <img :src="resultSrc" v-else width="100%">
        </div>
      </v-flex>
    </v-layout>



    <footer>Based on <a href="https://github.com/bunburya/bother">bother</a> by bunburya.</footer>
  </v-container>
</template>

<script>
  //import * as VueGoogleMaps from 'vue2-google-maps'

  import {Loader} from 'google-maps'
  import axios from 'axios'

  export default {
    name: 'HeightmapForm',
    //components: { VueGoogleMaps },
    props: {
      api_key: String,
      markers: Array,
    },
    data() {
      return {
        mapsScript: null,
        currentMap: null,
        drawingManager: null,
        rectangle: null,
        mapSearch: 'Kansas City, MO',
        latitude: 39.0997265, // KC
        longitude: -94.5785667, // KC
        apiKey: 'AIzaSyBWCAs1sBI2y1mAm00OZ1WG6zV5AWvmj8o',
        resultSrc: 'result.png',
        loading: false,
        lakes: false,
        scaleData: null,
        projection: null,
        raiseLow: null,
        raiseUndersea: null,
        maxBrightness: null,
        scaleImage: null,
        searchLoading: false

      }
    },
    computed: {
      bounds() {
        if (this.rectangle) {
          return this.rectangle.bounds;
        }

        return {}
      },
      botherCommand() {
        let command = 'bother --bounds '

        if (this.rectangle) {
          command += this.rectangle.bounds.getSouthWest().lat() + ' '
          command += this.rectangle.bounds.getSouthWest().lng() + ' '
          command += this.rectangle.bounds.getNorthEast().lat() + ' '
          command += this.rectangle.bounds.getNorthEast().lng() + ' '
        }

        return command
      },
      botherBounds() {
        let bounds = []
        if (this.rectangle) {
          bounds.push(this.rectangle.bounds.getSouthWest().lat())
          bounds.push(this.rectangle.bounds.getSouthWest().lng())
          bounds.push(this.rectangle.bounds.getNorthEast().lat())
          bounds.push(this.rectangle.bounds.getNorthEast().lng())
        }

        return bounds
      }
    },
    async mounted() {
      this.initCustomMaps()
    },
    methods: {
      initCustomMaps() {
        const options = {
          libraries: ['drawing']
        };

        new Loader(this.apiKey, options).load().then((result) => {
          this.mapsScript = result;

          //this.goToSearchedLocation()
          this.updateMap()

          let google = this.mapsScript

          this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.MARKER,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: [
                google.maps.drawing.OverlayType.RECTANGLE
              ]
            },
            markerOptions: {
              icon:
                      "https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png"
            },
            circleOptions: {
              fillColor: "#ffff00",
              fillOpacity: 1,
              strokeWeight: 5,
              clickable: false,
              editable: true,
              zIndex: 1
            }
          });
        });


      },
      updateMap() {
        let mapElement = document.getElementById('map');
        let mapLocation = new this.mapsScript.maps.LatLng(this.latitude, this.longitude);

        this.currentMap = new this.mapsScript.maps.Map(mapElement, {
          center: mapLocation,
          zoom: 7,
          mapTypeControl: false,
          fullscreenControl: false,
          rotateControl: false,
          scaleControl: false,
          streetViewControl: false,
          zoomControl: true,
        });

        //this.drawingManager.setMap(this.currentMap);

        let map = this.currentMap;
        let boxSizeLat = 2
        let boxSizeLon = 3

        this.rectangle = new this.mapsScript.maps.Rectangle({
          strokeColor: "#295b94",
          strokeOpacity: 0.8,
          strokeWeight: 4,
          //fillColor: "#FF0000",
          fillOpacity: 0.25,
          editable: true,
          draggable: true,
          map,
          bounds: {
            north: this.latitude + boxSizeLat,
            south: this.latitude - boxSizeLat,
            east: this.longitude + boxSizeLon,
            west: this.longitude - boxSizeLon
          }
        });

      },
      goToSearchedLocation() {
        this.searchLoading = true

        let geocodeOptions = {
          address: this.mapSearch
        };

        let geocoder = new this.mapsScript.maps.Geocoder();

        geocoder.geocode(geocodeOptions, (results, status) => {
          if (status === 'OK') {
            this.latitude = results[0].geometry.location.lat();
            this.longitude = results[0].geometry.location.lng();
            this.updateMap();
            this.searchLoading = false
          } else {
            //this.mapMessage = 'geocode error';
            //this.showMapMessage();
            console.log('geocode error')
            return;
          }
        });
      },
      generate () {
        console.log('starting...')
        this.loading = true

        let data = {
          bother: this.botherCommand,
          bounds: this.botherBounds,
          lakes: this.lakes
        }

        let $vm = this

        axios.post('/api.php', data)
                .then(function(response) {
                  // Update the image

                  //console.log(response.data)


                  $vm.resultSrc = response.data + '?t=' + new Date().getTime()
                  $vm.loading = false

                  //console.log('done')
                })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  #map {
    height: 600px;
    width: 100%;
    margin: 15px auto;
  }
  .optionForm {
    background-color: #EEE;
    padding: 10px;
    padding-bottom: 20px;
    margin-right: 20px;
    margin-bottom: 20px;
  }
</style>
